







import Modal from '@/project/modals/Modal.vue';
import { BaseContentModel } from '@/types/contentServerContract';
import { Component, Prop } from 'vue-property-decorator';
import contentApi from '@/core/http/contentApi.service';
import loggingService from '@/core/logging.service';
import SpinnerOverlay from '@/project/spinners/SpinnerOverlay.vue';

@Component({
    components: { SpinnerOverlay }
})
export default class ContentPageOverlay extends Modal {
    @Prop({ required: true, type: String })
    contentUrl!: string;

    content: BaseContentModel | null = null;
    loading: boolean = false;

    async getContent() {
        this.loading = true;

        try {
            this.content = await contentApi.getContent<BaseContentModel>(this.contentUrl);
        } catch (e) {
            loggingService.error(e);
        } finally {
            this.loading = false;
        }
    }

    created() {
        this.getContent();
    }
}
